<template>
<div>
  <div class="button-action visible-sp">
    <div class="button button-action-submit">
      <span role="button" class="btn" name="loguot" @click="submit">決定</span>
    </div>
    <div class="button button-action-close">
      <span role="button" class="btn" @click="close">
        <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
      </span>
    </div>
  </div>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md">
      <div class="button close visible-pc">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">複数の住所が該当しましたので、<br>選択してください。</span>
        </div>
        <div class="popup-content">
          <form @submit.prevent>
            <div class="formparts radio" v-for="(item, index) in group1.list" :key="index">
              <input type="radio" :id="'item_' + index" :value="index" v-model="group1.selectedItemIndex">
              <label :for="'item_' + index">{{item.address}}{{item.address2}}</label>
            </div>
            <div class="formparts radio">
              <input type="radio" id="item_direct" :value="-1" v-model="group1.selectedItemIndex">
              <label for="item_direct">住所を手動で入力する</label>
            </div>
            <div class="button mt32 visible-pc">
              <span role="button" class="btn" name="loguot" @click="submit">決定</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

export default defineComponent({
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup (props, context) {

    const group1 = reactive({
      list: props.list,
      selectedItemIndex: -1
    })

    // 閉じるボタン押下時
    const close = () => {
      context.emit('closeButtonClicked')
    }

    // サブミットボタン押下時
    const submit = () => {
      const selectedItemIndex = group1.selectedItemIndex ?? -1

      let address = ''
      let address2 = ''
      if (selectedItemIndex >= 0) {
        address = props.list[selectedItemIndex].address
        address2 = props.list[selectedItemIndex].address2
      }

      context.emit('submitButtonClicked', {address: address, address2: address2})
    }

    return {
      group1,
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content .button {
    width: 267px;
    margin-right: auto;
    margin-left: auto;
  }
</style>
